var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2667 12.1444H24.7556C16.6111 12.1444 10 18.8778 10 27.1667V58.3C10 66.5889 16.6111 73.3333 24.7333 73.3333H55.2667C63.3889 73.3333 70 66.5889 70 58.3V27.1667C70 18.8778 63.3889 12.1333 55.2667 12.1333V12.1444ZM24.7333 15.4889H55.2444C61.5667 15.4889 66.7 20.7333 66.7 27.1778V58.3111C66.7333 64.7556 61.5889 70 55.2778 70H24.7333C18.4111 70 13.2778 64.7556 13.2778 58.3111V27.1778C13.2778 20.7333 18.4222 15.4889 24.7333 15.4889Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35H55",
    stroke: "#C18344",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42.5H55",
    stroke: "#C18344",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 50H55",
    stroke: "#C18344",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57.5H45",
    stroke: "#C18344",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.5C29.4477 27.5 29 27.0523 29 26.5C29 25.9477 29.4477 25.5 30 25.5H38C38.5523 25.5 39 25.9477 39 26.5C39 27.0523 38.5523 27.5 38 27.5H30Z",
    fill: "#C18344"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27.5C40.4477 27.5 40 27.0523 40 26.5C40 25.9477 40.4477 25.5 41 25.5H49C49.5523 25.5 50 25.9477 50 26.5C50 27.0523 49.5523 27.5 49 27.5H41Z",
    fill: "#C18344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulations);
export default __webpack_public_path__ + "static/media/regulations.501129f0f271362318ebac0190d749c1.svg";
export { ForwardRef as ReactComponent };